import { render, staticRenderFns } from "./EntityTypeEmpty.vue?vue&type=template&id=f66d933e&"
import script from "./EntityTypeEmpty.vue?vue&type=script&lang=ts&"
export * from "./EntityTypeEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports